import { Navigate } from 'react-router-dom';
import { ModuleGate } from '@/access/Gate';
import type { ModuleKey } from '@/access/modules';

/** נתיב של מודול כבוי מחזיר 404 שקט, לא "אין הרשאה": מבחינת העובד הוא לא קיים. */
export function ModuleRoute({
  module,
  children,
}: {
  module: ModuleKey;
  children: React.ReactNode;
}) {
  return (
    <ModuleGate module={module} fallback={<Navigate to="/" replace />}>
      {children}
    </ModuleGate>
  );
}
